/* GGR-style Shopify CRO listicle shared interactions
   Loaded only by generated sections: sections/ggr-listicle-[topic].liquid */

(function () {
  function getRootFromElement(element) {
    return element && element.closest ? element.closest('.us-listicle') : null;
  }

  function scrollToAnchor(anchor) {
    var href = anchor.getAttribute('href');
    if (!href || href === '#' || href.charAt(0) !== '#') return;

    var root = getRootFromElement(anchor) || document;
    var target = root.querySelector(href) || document.querySelector(href);
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function replaceBenefitIcons(root) {
    var benefitIcons = {
      value: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-2.64-6.36"></path><path d="M21 3v6h-6"></path></svg>',
      shipping: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H3v14h2"></path><path d="M15 18H9"></path><path d="M19 18h2v-5l-3-4h-4"></path><circle cx="7" cy="18" r="2"></circle><circle cx="17" cy="18" r="2"></circle></svg>',
      formula: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 2v6l-5 9a4 4 0 0 0 3.5 6h7a4 4 0 0 0 3.5-6l-5-9V2"></path><path d="M8 2h8"></path><path d="M7 16h10"></path></svg>'
    };

    root.querySelectorAll('.us-review-benefits li').forEach(function (li, index) {
      if (li.dataset.usIconReady === 'true') return;

      var raw = li.textContent.trim();
      var icon = benefitIcons.value;
      var clean = raw.replace(/^↻\s*/, '');

      if (raw.indexOf('Singapore availability') !== -1 || raw.indexOf('shipping') !== -1 || raw.indexOf('Shipping') !== -1 || raw.indexOf('🚚') === 0) {
        icon = benefitIcons.shipping;
        clean = raw.replace(/^🚚\s*/, '');
      } else if (raw.indexOf('formula') !== -1 || raw.indexOf('Formula') !== -1 || raw.indexOf('⚗') === 0 || index % 3 === 2) {
        icon = benefitIcons.formula;
        clean = raw.replace(/^⚗\s*/, '');
      }

      li.innerHTML = icon + '<span>' + clean + '</span>';
      li.dataset.usIconReady = 'true';
    });
  }

  function initScoringTabs(root) {
    var panel = root.querySelector('.us-scoring-panel');
    var tabs = root.querySelectorAll('.us-scoring-tab');
    if (!panel || !tabs.length) return;

    tabs.forEach(function (tab) {
      tab.setAttribute('role', 'button');
      tab.setAttribute('tabindex', '0');

      var activate = function () {
        var target = tab.getAttribute('data-tab-target');
        var template = target ? root.querySelector('[data-scoring-panel="' + target + '"]') : null;

        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');

        if (template) {
          panel.innerHTML = template.innerHTML;
        }
      };

      tab.addEventListener('click', activate);
      tab.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activate();
        }
      });
    });
  }

  function initProductTabs(root) {
    root.querySelectorAll('.us-product-review-card').forEach(function (card) {
      var panel = card.querySelector('.us-pros-cons-panel');
      if (!panel) return;

      card.querySelectorAll('.us-review-tab').forEach(function (tab) {
        tab.setAttribute('role', 'button');
        tab.setAttribute('tabindex', '0');

        var activate = function () {
          var target = tab.getAttribute('data-tab-target');
          var template = target ? card.querySelector('[data-review-panel="' + target + '"]') : null;

          card.querySelectorAll('.us-review-tab').forEach(function (t) { t.classList.remove('active'); });
          tab.classList.add('active');

          if (template) {
            panel.innerHTML = template.innerHTML;
          }
        };

        tab.addEventListener('click', activate);
        tab.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activate();
          }
        });
      });
    });
  }

  function initReadMore(root) {
    root.querySelectorAll('.us-read-toggle').forEach(function (button) {
      button.addEventListener('click', function () {
        var section = button.closest('.us-review-section');
        if (!section) return;

        var card = section.querySelector('.us-product-review-card');
        var expanded = section.querySelector('.us-expanded-content');
        var topButton = section.querySelector('.us-glance + .us-read-toggle');
        var shouldExpand = button.textContent.trim() === 'Read More';

        if (card) card.classList.toggle('is-expanded', shouldExpand);
        if (expanded) expanded.style.display = shouldExpand ? 'block' : 'none';

        if (topButton) {
          topButton.style.display = shouldExpand ? 'none' : 'block';
          topButton.setAttribute('aria-expanded', shouldExpand ? 'true' : 'false');
        }

        if (!shouldExpand && section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initSmoothAnchors(root) {
    root.querySelectorAll('.us-sidebar a, a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (event) {
        var href = anchor.getAttribute('href');
        if (!href || href === '#' || href.charAt(0) !== '#') return;
        var target = root.querySelector(href) || document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        scrollToAnchor(anchor);
      });
    });
  }

  function initJavvyAdvertorial(root) {
    if (!root.classList || !root.classList.contains('us-javvy-advertorial')) return;
    if (root.dataset.javvyAdvertorialReady === 'true') return;
    root.dataset.javvyAdvertorialReady = 'true';

    var startDays = Number(root.getAttribute('data-countdown-days')) || 0;
    var startHours = Number(root.getAttribute('data-countdown-hours')) || 0;
    var startMinutes = Number(root.getAttribute('data-countdown-minutes')) || 0;
    var startSeconds = Number(root.getAttribute('data-countdown-seconds')) || 0;
    var durationMs = (((startDays * 24 + startHours) * 60 + startMinutes) * 60 + startSeconds) * 1000;
    var storageKey = root.getAttribute('data-countdown-storage-key') || 'top_reason_offer_started_at_' + (root.id || 'default');
    var countdownTimer;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function getRemainingMs() {
      var startedAt = Number(window.localStorage && localStorage.getItem(storageKey));
      if (!startedAt) return durationMs;
      return Math.max(0, durationMs - (Date.now() - startedAt));
    }

    function updateCountdown() {
      var totalSeconds = Math.floor(getRemainingMs() / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      root.querySelectorAll('[data-offer-days]').forEach(function (el) { el.textContent = days; });
      root.querySelectorAll('[data-offer-hours]').forEach(function (el) { el.textContent = pad(hours); });
      root.querySelectorAll('[data-offer-minutes]').forEach(function (el) { el.textContent = pad(minutes); });
      root.querySelectorAll('[data-offer-seconds]').forEach(function (el) { el.textContent = pad(seconds); });
    }

    function startOfferTimer() {
      if (window.localStorage && !localStorage.getItem(storageKey)) {
        localStorage.setItem(storageKey, String(Date.now()));
      }
      updateCountdown();
      if (!countdownTimer) countdownTimer = setInterval(updateCountdown, 1000);
    }

    root.querySelectorAll('[data-claim-offer]').forEach(function (trigger) {
      trigger.addEventListener('click', startOfferTimer);
    });

    root.querySelectorAll('[data-offer-card]').forEach(function (card) {
      card.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        root.querySelectorAll('[data-offer-card]').forEach(function (otherCard) {
          otherCard.classList.remove('is-active');
        });
        card.classList.add('is-active');

        var image = root.querySelector('[data-bundle-image]');
        var nextImage = card.getAttribute('data-bundle-image-src');
        if (image && nextImage) image.setAttribute('src', nextImage);
      });
    });

    root.querySelectorAll('[data-product-url]').forEach(function (card) {
      card.addEventListener('click', function (event) {
        if (event.target && event.target.closest && event.target.closest('[data-offer-card]')) return;
        var url = card.getAttribute('data-product-url');
        if (url) window.location.href = url;
      });
    });

    var mobileCta = root.querySelector('.jv2-mobile-cta');
    var reason3 = root.querySelector('#reason-3');
    var dealCard = root.querySelector('.jv2-deal-card');
    var dealCopy = root.querySelector('.jv2-deal-copy');
    var countdown = root.querySelector('.jv2-countdown');
    var mobileCtaParent = mobileCta && mobileCta.parentNode;
    var mobileCtaNext = mobileCta && mobileCta.nextSibling;

    if (mobileCta && reason3 && dealCard && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          mobileCta.classList.add('is-visible');
          observer.disconnect();
        });
      }, { threshold: 0.15 }).observe(reason3);

      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var dock = entry.isIntersecting;
          mobileCta.classList.toggle('is-docked', dock);

          if (dock && dealCopy && !dealCopy.contains(mobileCta)) {
            dealCopy.insertBefore(mobileCta, countdown || null);
          } else if (!dock && mobileCtaParent && mobileCta.parentNode !== mobileCtaParent) {
            mobileCtaParent.insertBefore(mobileCta, mobileCtaNext);
          }
        });
      }, { threshold: 0.15 }).observe(dealCard);
    }

    updateCountdown();
    if (window.localStorage && localStorage.getItem(storageKey)) {
      countdownTimer = setInterval(updateCountdown, 1000);
    }
  }

  function initListicle(root) {
    if (!root || root.dataset.ggrListicleReady === 'true') return;
    root.dataset.ggrListicleReady = 'true';

    replaceBenefitIcons(root);
    initScoringTabs(root);
    initProductTabs(root);
    initReadMore(root);
    initSmoothAnchors(root);
    initJavvyAdvertorial(root);
  }

  function initAll() {
    document.querySelectorAll('.us-listicle').forEach(initListicle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    event.target.querySelectorAll('.us-listicle').forEach(initListicle);
  });
})();
